export default __webpack_public_path__ + "static/media/025-ipod.67f8be36.svg";